import type { TechnologyIconSources } from '../technology-icon-sources';
import type { TechnologyIconName } from '../supported-icon-names';

export const technologyIconLoaders: Record<
  TechnologyIconName,
  () => Promise<TechnologyIconSources>
> = {
  adobe: () => import('./adobe').then((module) => module.technologyIcon),
  adobefirefly: () => import('./adobefirefly').then((module) => module.technologyIcon),
  adobeicon: () => import('./adobeicon').then((module) => module.technologyIcon),
  adobeillustrator: () => import('./adobeillustrator').then((module) => module.technologyIcon),
  ae: () => import('./ae').then((module) => module.technologyIcon),
  affinity: () => import('./affinity').then((module) => module.technologyIcon),
  affinitydesigner: () => import('./affinitydesigner').then((module) => module.technologyIcon),
  affinityphoto: () => import('./affinityphoto').then((module) => module.technologyIcon),
  affinitypublisher: () => import('./affinitypublisher').then((module) => module.technologyIcon),
  ai21labsai: () => import('./ai21labsai').then((module) => module.technologyIcon),
  ai2ai: () => import('./ai2ai').then((module) => module.technologyIcon),
  ai360: () => import('./ai360').then((module) => module.technologyIcon),
  aihubmix: () => import('./aihubmix').then((module) => module.technologyIcon),
  aimass: () => import('./aimass').then((module) => module.technologyIcon),
  aionlabs: () => import('./aionlabs').then((module) => module.technologyIcon),
  airtable: () => import('./airtable').then((module) => module.technologyIcon),
  aistudio: () => import('./aistudio').then((module) => module.technologyIcon),
  alacritty: () => import('./alacritty').then((module) => module.technologyIcon),
  algolia: () => import('./algolia').then((module) => module.technologyIcon),
  algorand: () => import('./algorand').then((module) => module.technologyIcon),
  alibabacloud: () => import('./alibabacloud').then((module) => module.technologyIcon),
  alpinejs: () => import('./alpinejs').then((module) => module.technologyIcon),
  amp: () => import('./amp').then((module) => module.technologyIcon),
  amplitude: () => import('./amplitude').then((module) => module.technologyIcon),
  amznwebserv: () => import('./amznwebserv').then((module) => module.technologyIcon),
  analytics: () => import('./analytics').then((module) => module.technologyIcon),
  android: () => import('./android').then((module) => module.technologyIcon),
  angular: () => import('./angular').then((module) => module.technologyIcon),
  angular17: () => import('./angular17').then((module) => module.technologyIcon),
  animaapp: () => import('./animaapp').then((module) => module.technologyIcon),
  antd: () => import('./antd').then((module) => module.technologyIcon),
  antgroup: () => import('./antgroup').then((module) => module.technologyIcon),
  anthropic: () => import('./anthropic').then((module) => module.technologyIcon),
  antigravity: () => import('./antigravity').then((module) => module.technologyIcon),
  anyscale: () => import('./anyscale').then((module) => module.technologyIcon),
  apache: () => import('./apache').then((module) => module.technologyIcon),
  appwrite: () => import('./appwrite').then((module) => module.technologyIcon),
  arc: () => import('./arc').then((module) => module.technologyIcon),
  arceeai: () => import('./arceeai').then((module) => module.technologyIcon),
  asana: () => import('./asana').then((module) => module.technologyIcon),
  assemblyai: () => import('./assemblyai').then((module) => module.technologyIcon),
  astro: () => import('./astro').then((module) => module.technologyIcon),
  atlassian: () => import('./atlassian').then((module) => module.technologyIcon),
  atom: () => import('./atom').then((module) => module.technologyIcon),
  augment: () => import('./augment').then((module) => module.technologyIcon),
  auth0: () => import('./auth0').then((module) => module.technologyIcon),
  automatic: () => import('./automatic').then((module) => module.technologyIcon),
  avajs: () => import('./avajs').then((module) => module.technologyIcon),
  aws: () => import('./aws').then((module) => module.technologyIcon),
  axiom: () => import('./axiom').then((module) => module.technologyIcon),
  axm: () => import('./axm').then((module) => module.technologyIcon),
  axure: () => import('./axure').then((module) => module.technologyIcon),
  aya: () => import('./aya').then((module) => module.technologyIcon),
  azure: () => import('./azure').then((module) => module.technologyIcon),
  azureai: () => import('./azureai').then((module) => module.technologyIcon),
  baaiai: () => import('./baaiai').then((module) => module.technologyIcon),
  babel: () => import('./babel').then((module) => module.technologyIcon),
  backbonejs: () => import('./backbonejs').then((module) => module.technologyIcon),
  baichuan: () => import('./baichuan').then((module) => module.technologyIcon),
  baidu: () => import('./baidu').then((module) => module.technologyIcon),
  baiducloud: () => import('./baiducloud').then((module) => module.technologyIcon),
  baseui: () => import('./baseui').then((module) => module.technologyIcon),
  bash: () => import('./bash').then((module) => module.technologyIcon),
  bedrock: () => import('./bedrock').then((module) => module.technologyIcon),
  bilibiliai: () => import('./bilibiliai').then((module) => module.technologyIcon),
  bing: () => import('./bing').then((module) => module.technologyIcon),
  biomejs: () => import('./biomejs').then((module) => module.technologyIcon),
  bitbucket: () => import('./bitbucket').then((module) => module.technologyIcon),
  bitnami: () => import('./bitnami').then((module) => module.technologyIcon),
  blitz: () => import('./blitz').then((module) => module.technologyIcon),
  blueprintjs: () => import('./blueprintjs').then((module) => module.technologyIcon),
  bolt: () => import('./bolt').then((module) => module.technologyIcon),
  bootstrap4: () => import('./bootstrap4').then((module) => module.technologyIcon),
  bootstrap5: () => import('./bootstrap5').then((module) => module.technologyIcon),
  brave: () => import('./brave').then((module) => module.technologyIcon),
  brunch: () => import('./brunch').then((module) => module.technologyIcon),
  builder: () => import('./builder').then((module) => module.technologyIcon),
  buildship: () => import('./buildship').then((module) => module.technologyIcon),
  bulmaui: () => import('./bulmaui').then((module) => module.technologyIcon),
  bunjs: () => import('./bunjs').then((module) => module.technologyIcon),
  bytedance: () => import('./bytedance').then((module) => module.technologyIcon),
  cakephp: () => import('./cakephp').then((module) => module.technologyIcon),
  canva: () => import('./canva').then((module) => module.technologyIcon),
  cassandradb: () => import('./cassandradb').then((module) => module.technologyIcon),
  centml: () => import('./centml').then((module) => module.technologyIcon),
  cerebras: () => import('./cerebras').then((module) => module.technologyIcon),
  chakraui: () => import('./chakraui').then((module) => module.technologyIcon),
  chatglm: () => import('./chatglm').then((module) => module.technologyIcon),
  chrome: () => import('./chrome').then((module) => module.technologyIcon),
  chromium: () => import('./chromium').then((module) => module.technologyIcon),
  circleci: () => import('./circleci').then((module) => module.technologyIcon),
  civitai: () => import('./civitai').then((module) => module.technologyIcon),
  claude: () => import('./claude').then((module) => module.technologyIcon),
  clerk: () => import('./clerk').then((module) => module.technologyIcon),
  clickhouse: () => import('./clickhouse').then((module) => module.technologyIcon),
  cline: () => import('./cline').then((module) => module.technologyIcon),
  clojure: () => import('./clojure').then((module) => module.technologyIcon),
  cloudflare: () => import('./cloudflare').then((module) => module.technologyIcon),
  cloudinary: () => import('./cloudinary').then((module) => module.technologyIcon),
  codefresh: () => import('./codefresh').then((module) => module.technologyIcon),
  codegeex: () => import('./codegeex').then((module) => module.technologyIcon),
  codeigniter: () => import('./codeigniter').then((module) => module.technologyIcon),
  coderabbit: () => import('./coderabbit').then((module) => module.technologyIcon),
  cogvideo: () => import('./cogvideo').then((module) => module.technologyIcon),
  cogview: () => import('./cogview').then((module) => module.technologyIcon),
  colab: () => import('./colab').then((module) => module.technologyIcon),
  comfyui: () => import('./comfyui').then((module) => module.technologyIcon),
  commanda: () => import('./commanda').then((module) => module.technologyIcon),
  commandai: () => import('./commandai').then((module) => module.technologyIcon),
  convex: () => import('./convex').then((module) => module.technologyIcon),
  copilotgithub: () => import('./copilotgithub').then((module) => module.technologyIcon),
  copilotms: () => import('./copilotms').then((module) => module.technologyIcon),
  coqui: () => import('./coqui').then((module) => module.technologyIcon),
  crewai: () => import('./crewai').then((module) => module.technologyIcon),
  crusoe: () => import('./crusoe').then((module) => module.technologyIcon),
  crystal: () => import('./crystal').then((module) => module.technologyIcon),
  csharp: () => import('./csharp').then((module) => module.technologyIcon),
  css3: () => import('./css3').then((module) => module.technologyIcon),
  cursor: () => import('./cursor').then((module) => module.technologyIcon),
  cypress: () => import('./cypress').then((module) => module.technologyIcon),
  dalle: () => import('./dalle').then((module) => module.technologyIcon),
  dart: () => import('./dart').then((module) => module.technologyIcon),
  datadog: () => import('./datadog').then((module) => module.technologyIcon),
  dbrx: () => import('./dbrx').then((module) => module.technologyIcon),
  deepcogitoai: () => import('./deepcogitoai').then((module) => module.technologyIcon),
  deepinfra: () => import('./deepinfra').then((module) => module.technologyIcon),
  deepmind: () => import('./deepmind').then((module) => module.technologyIcon),
  deepseek: () => import('./deepseek').then((module) => module.technologyIcon),
  deno: () => import('./deno').then((module) => module.technologyIcon),
  digitalocean: () => import('./digitalocean').then((module) => module.technologyIcon),
  django: () => import('./django').then((module) => module.technologyIcon),
  dlang: () => import('./dlang').then((module) => module.technologyIcon),
  doc2x: () => import('./doc2x').then((module) => module.technologyIcon),
  docker: () => import('./docker').then((module) => module.technologyIcon),
  docsearch: () => import('./docsearch').then((module) => module.technologyIcon),
  docusaurus: () => import('./docusaurus').then((module) => module.technologyIcon),
  dojo: () => import('./dojo').then((module) => module.technologyIcon),
  doubao: () => import('./doubao').then((module) => module.technologyIcon),
  dovetail: () => import('./dovetail').then((module) => module.technologyIcon),
  dphnAIai: () => import('./dphnAIai').then((module) => module.technologyIcon),
  drizzle: () => import('./drizzle').then((module) => module.technologyIcon),
  ec2: () => import('./ec2').then((module) => module.technologyIcon),
  edge: () => import('./edge').then((module) => module.technologyIcon),
  elastic: () => import('./elastic').then((module) => module.technologyIcon),
  electron: () => import('./electron').then((module) => module.technologyIcon),
  elementui: () => import('./elementui').then((module) => module.technologyIcon),
  elevenlabsai: () => import('./elevenlabsai').then((module) => module.technologyIcon),
  elixir: () => import('./elixir').then((module) => module.technologyIcon),
  ember: () => import('./ember').then((module) => module.technologyIcon),
  erlang: () => import('./erlang').then((module) => module.technologyIcon),
  esbuild: () => import('./esbuild').then((module) => module.technologyIcon),
  eslint: () => import('./eslint').then((module) => module.technologyIcon),
  essentialaiai: () => import('./essentialaiai').then((module) => module.technologyIcon),
  exa: () => import('./exa').then((module) => module.technologyIcon),
  expo: () => import('./expo').then((module) => module.technologyIcon),
  expressjs: () => import('./expressjs').then((module) => module.technologyIcon),
  fabricjs: () => import('./fabricjs').then((module) => module.technologyIcon),
  fastgpt: () => import('./fastgpt').then((module) => module.technologyIcon),
  faunadb: () => import('./faunadb').then((module) => module.technologyIcon),
  featherless: () => import('./featherless').then((module) => module.technologyIcon),
  figma: () => import('./figma').then((module) => module.technologyIcon),
  firebase: () => import('./firebase').then((module) => module.technologyIcon),
  firefly: () => import('./firefly').then((module) => module.technologyIcon),
  firefox: () => import('./firefox').then((module) => module.technologyIcon),
  fireworks: () => import('./fireworks').then((module) => module.technologyIcon),
  fishaudioai: () => import('./fishaudioai').then((module) => module.technologyIcon),
  flask: () => import('./flask').then((module) => module.technologyIcon),
  flutter: () => import('./flutter').then((module) => module.technologyIcon),
  flutterflow: () => import('./flutterflow').then((module) => module.technologyIcon),
  fluxai: () => import('./fluxai').then((module) => module.technologyIcon),
  flyio: () => import('./flyio').then((module) => module.technologyIcon),
  framer: () => import('./framer').then((module) => module.technologyIcon),
  gatsby: () => import('./gatsby').then((module) => module.technologyIcon),
  gcloud: () => import('./gcloud').then((module) => module.technologyIcon),
  gemini: () => import('./gemini').then((module) => module.technologyIcon),
  gemma: () => import('./gemma').then((module) => module.technologyIcon),
  git: () => import('./git').then((module) => module.technologyIcon),
  github: () => import('./github').then((module) => module.technologyIcon),
  gitlab: () => import('./gitlab').then((module) => module.technologyIcon),
  glmvai: () => import('./glmvai').then((module) => module.technologyIcon),
  go: () => import('./go').then((module) => module.technologyIcon),
  google: () => import('./google').then((module) => module.technologyIcon),
  gradio: () => import('./gradio').then((module) => module.technologyIcon),
  grafana: () => import('./grafana').then((module) => module.technologyIcon),
  grafbase: () => import('./grafbase').then((module) => module.technologyIcon),
  graphite: () => import('./graphite').then((module) => module.technologyIcon),
  graphql: () => import('./graphql').then((module) => module.technologyIcon),
  greptile: () => import('./greptile').then((module) => module.technologyIcon),
  gridsome: () => import('./gridsome').then((module) => module.technologyIcon),
  grok: () => import('./grok').then((module) => module.technologyIcon),
  groq: () => import('./groq').then((module) => module.technologyIcon),
  gruntjs: () => import('./gruntjs').then((module) => module.technologyIcon),
  gsap: () => import('./gsap').then((module) => module.technologyIcon),
  gsap2: () => import('./gsap2').then((module) => module.technologyIcon),
  gulp: () => import('./gulp').then((module) => module.technologyIcon),
  hailuo: () => import('./hailuo').then((module) => module.technologyIcon),
  haskell: () => import('./haskell').then((module) => module.technologyIcon),
  headlessui: () => import('./headlessui').then((module) => module.technologyIcon),
  heroku: () => import('./heroku').then((module) => module.technologyIcon),
  hexo: () => import('./hexo').then((module) => module.technologyIcon),
  hhvm: () => import('./hhvm').then((module) => module.technologyIcon),
  higress: () => import('./higress').then((module) => module.technologyIcon),
  homebrew: () => import('./homebrew').then((module) => module.technologyIcon),
  hono: () => import('./hono').then((module) => module.technologyIcon),
  hotjar: () => import('./hotjar').then((module) => module.technologyIcon),
  html5: () => import('./html5').then((module) => module.technologyIcon),
  huggingface: () => import('./huggingface').then((module) => module.technologyIcon),
  hugo: () => import('./hugo').then((module) => module.technologyIcon),
  hunyuan: () => import('./hunyuan').then((module) => module.technologyIcon),
  hyper: () => import('./hyper').then((module) => module.technologyIcon),
  hyper2: () => import('./hyper2').then((module) => module.technologyIcon),
  hyperbolic: () => import('./hyperbolic').then((module) => module.technologyIcon),
  i18next: () => import('./i18next').then((module) => module.technologyIcon),
  id: () => import('./id').then((module) => module.technologyIcon),
  ie: () => import('./ie').then((module) => module.technologyIcon),
  iflytekcloud: () => import('./iflytekcloud').then((module) => module.technologyIcon),
  inceptionai: () => import('./inceptionai').then((module) => module.technologyIcon),
  infermatic: () => import('./infermatic').then((module) => module.technologyIcon),
  infinigence: () => import('./infinigence').then((module) => module.technologyIcon),
  inflectionai: () => import('./inflectionai').then((module) => module.technologyIcon),
  inkspace: () => import('./inkspace').then((module) => module.technologyIcon),
  insomnia: () => import('./insomnia').then((module) => module.technologyIcon),
  internlm: () => import('./internlm').then((module) => module.technologyIcon),
  invision: () => import('./invision').then((module) => module.technologyIcon),
  ionic: () => import('./ionic').then((module) => module.technologyIcon),
  jamstack: () => import('./jamstack').then((module) => module.technologyIcon),
  java: () => import('./java').then((module) => module.technologyIcon),
  jest: () => import('./jest').then((module) => module.technologyIcon),
  jimeng: () => import('./jimeng').then((module) => module.technologyIcon),
  jina: () => import('./jina').then((module) => module.technologyIcon),
  jira: () => import('./jira').then((module) => module.technologyIcon),
  jquery: () => import('./jquery').then((module) => module.technologyIcon),
  js: () => import('./js').then((module) => module.technologyIcon),
  jslint: () => import('./jslint').then((module) => module.technologyIcon),
  json: () => import('./json').then((module) => module.technologyIcon),
  kibana: () => import('./kibana').then((module) => module.technologyIcon),
  kimi: () => import('./kimi').then((module) => module.technologyIcon),
  kling: () => import('./kling').then((module) => module.technologyIcon),
  kluster: () => import('./kluster').then((module) => module.technologyIcon),
  kolorsai: () => import('./kolorsai').then((module) => module.technologyIcon),
  kotlin: () => import('./kotlin').then((module) => module.technologyIcon),
  kubernetes: () => import('./kubernetes').then((module) => module.technologyIcon),
  kwaikatai: () => import('./kwaikatai').then((module) => module.technologyIcon),
  kwaipilotai: () => import('./kwaipilotai').then((module) => module.technologyIcon),
  langchain: () => import('./langchain').then((module) => module.technologyIcon),
  langfuse: () => import('./langfuse').then((module) => module.technologyIcon),
  langgraph: () => import('./langgraph').then((module) => module.technologyIcon),
  langsmith: () => import('./langsmith').then((module) => module.technologyIcon),
  laravel: () => import('./laravel').then((module) => module.technologyIcon),
  leptonai: () => import('./leptonai').then((module) => module.technologyIcon),
  less: () => import('./less').then((module) => module.technologyIcon),
  lightroom: () => import('./lightroom').then((module) => module.technologyIcon),
  linear: () => import('./linear').then((module) => module.technologyIcon),
  linux: () => import('./linux').then((module) => module.technologyIcon),
  liquidaiai: () => import('./liquidaiai').then((module) => module.technologyIcon),
  lit: () => import('./lit').then((module) => module.technologyIcon),
  liveblocks: () => import('./liveblocks').then((module) => module.technologyIcon),
  livekit: () => import('./livekit').then((module) => module.technologyIcon),
  llamaindex: () => import('./llamaindex').then((module) => module.technologyIcon),
  llava: () => import('./llava').then((module) => module.technologyIcon),
  logrocket: () => import('./logrocket').then((module) => module.technologyIcon),
  lokalise: () => import('./lokalise').then((module) => module.technologyIcon),
  longcatai: () => import('./longcatai').then((module) => module.technologyIcon),
  lovable: () => import('./lovable').then((module) => module.technologyIcon),
  lua: () => import('./lua').then((module) => module.technologyIcon),
  luma: () => import('./luma').then((module) => module.technologyIcon),
  lunacy: () => import('./lunacy').then((module) => module.technologyIcon),
  magicai: () => import('./magicai').then((module) => module.technologyIcon),
  make: () => import('./make').then((module) => module.technologyIcon),
  mariadb: () => import('./mariadb').then((module) => module.technologyIcon),
  marionette: () => import('./marionette').then((module) => module.technologyIcon),
  markdown: () => import('./markdown').then((module) => module.technologyIcon),
  materialui: () => import('./materialui').then((module) => module.technologyIcon),
  meta: () => import('./meta').then((module) => module.technologyIcon),
  metaai: () => import('./metaai').then((module) => module.technologyIcon),
  microsoft: () => import('./microsoft').then((module) => module.technologyIcon),
  minimax: () => import('./minimax').then((module) => module.technologyIcon),
  miro: () => import('./miro').then((module) => module.technologyIcon),
  mistral: () => import('./mistral').then((module) => module.technologyIcon),
  mochajs: () => import('./mochajs').then((module) => module.technologyIcon),
  modelscope: () => import('./modelscope').then((module) => module.technologyIcon),
  mongodb: () => import('./mongodb').then((module) => module.technologyIcon),
  mongoose: () => import('./mongoose').then((module) => module.technologyIcon),
  monica: () => import('./monica').then((module) => module.technologyIcon),
  morphai: () => import('./morphai').then((module) => module.technologyIcon),
  mozilla: () => import('./mozilla').then((module) => module.technologyIcon),
  myshell: () => import('./myshell').then((module) => module.technologyIcon),
  mysql: () => import('./mysql').then((module) => module.technologyIcon),
  n8n: () => import('./n8n').then((module) => module.technologyIcon),
  neon: () => import('./neon').then((module) => module.technologyIcon),
  neovim: () => import('./neovim').then((module) => module.technologyIcon),
  nestjs: () => import('./nestjs').then((module) => module.technologyIcon),
  net: () => import('./net').then((module) => module.technologyIcon),
  netcore: () => import('./netcore').then((module) => module.technologyIcon),
  netlify: () => import('./netlify').then((module) => module.technologyIcon),
  netlify2: () => import('./netlify2').then((module) => module.technologyIcon),
  nextjs: () => import('./nextjs').then((module) => module.technologyIcon),
  nextjs2: () => import('./nextjs2').then((module) => module.technologyIcon),
  nim: () => import('./nim').then((module) => module.technologyIcon),
  nitro: () => import('./nitro').then((module) => module.technologyIcon),
  nodejs: () => import('./nodejs').then((module) => module.technologyIcon),
  notion: () => import('./notion').then((module) => module.technologyIcon),
  nova: () => import('./nova').then((module) => module.technologyIcon),
  novamodelai: () => import('./novamodelai').then((module) => module.technologyIcon),
  novita: () => import('./novita').then((module) => module.technologyIcon),
  nplcloud: () => import('./nplcloud').then((module) => module.technologyIcon),
  npm: () => import('./npm').then((module) => module.technologyIcon),
  npm2: () => import('./npm2').then((module) => module.technologyIcon),
  nuxtjs: () => import('./nuxtjs').then((module) => module.technologyIcon),
  nvidia: () => import('./nvidia').then((module) => module.technologyIcon),
  ocaml: () => import('./ocaml').then((module) => module.technologyIcon),
  onedrive: () => import('./onedrive').then((module) => module.technologyIcon),
  openai: () => import('./openai').then((module) => module.technologyIcon),
  openchat: () => import('./openchat').then((module) => module.technologyIcon),
  opencode: () => import('./opencode').then((module) => module.technologyIcon),
  opera: () => import('./opera').then((module) => module.technologyIcon),
  oracle: () => import('./oracle').then((module) => module.technologyIcon),
  palmai: () => import('./palmai').then((module) => module.technologyIcon),
  pandacss: () => import('./pandacss').then((module) => module.technologyIcon),
  payload: () => import('./payload').then((module) => module.technologyIcon),
  perplexity: () => import('./perplexity').then((module) => module.technologyIcon),
  phidata: () => import('./phidata').then((module) => module.technologyIcon),
  phindai: () => import('./phindai').then((module) => module.technologyIcon),
  phoenix: () => import('./phoenix').then((module) => module.technologyIcon),
  php: () => import('./php').then((module) => module.technologyIcon),
  pinia: () => import('./pinia').then((module) => module.technologyIcon),
  pixijs: () => import('./pixijs').then((module) => module.technologyIcon),
  pixverse: () => import('./pixverse').then((module) => module.technologyIcon),
  playwright: () => import('./playwright').then((module) => module.technologyIcon),
  poe: () => import('./poe').then((module) => module.technologyIcon),
  postgresql: () => import('./postgresql').then((module) => module.technologyIcon),
  posthog: () => import('./posthog').then((module) => module.technologyIcon),
  postman: () => import('./postman').then((module) => module.technologyIcon),
  powershell: () => import('./powershell').then((module) => module.technologyIcon),
  ppio: () => import('./ppio').then((module) => module.technologyIcon),
  preact: () => import('./preact').then((module) => module.technologyIcon),
  presto: () => import('./presto').then((module) => module.technologyIcon),
  prettier: () => import('./prettier').then((module) => module.technologyIcon),
  prisma: () => import('./prisma').then((module) => module.technologyIcon),
  prometheus: () => import('./prometheus').then((module) => module.technologyIcon),
  ps: () => import('./ps').then((module) => module.technologyIcon),
  pugjs: () => import('./pugjs').then((module) => module.technologyIcon),
  pwa: () => import('./pwa').then((module) => module.technologyIcon),
  pydanticai: () => import('./pydanticai').then((module) => module.technologyIcon),
  python: () => import('./python').then((module) => module.technologyIcon),
  pytorch: () => import('./pytorch').then((module) => module.technologyIcon),
  pytorch3d: () => import('./pytorch3d').then((module) => module.technologyIcon),
  qingyan: () => import('./qingyan').then((module) => module.technologyIcon),
  qiniu: () => import('./qiniu').then((module) => module.technologyIcon),
  qwen: () => import('./qwen').then((module) => module.technologyIcon),
  qwik: () => import('./qwik').then((module) => module.technologyIcon),
  radixui: () => import('./radixui').then((module) => module.technologyIcon),
  rails: () => import('./rails').then((module) => module.technologyIcon),
  railway: () => import('./railway').then((module) => module.technologyIcon),
  react: () => import('./react').then((module) => module.technologyIcon),
  reactquery: () => import('./reactquery').then((module) => module.technologyIcon),
  reactrouter: () => import('./reactrouter').then((module) => module.technologyIcon),
  redhat: () => import('./redhat').then((module) => module.technologyIcon),
  redis: () => import('./redis').then((module) => module.technologyIcon),
  redux: () => import('./redux').then((module) => module.technologyIcon),
  reduxsaga: () => import('./reduxsaga').then((module) => module.technologyIcon),
  redwoodjs: () => import('./redwoodjs').then((module) => module.technologyIcon),
  relaceai: () => import('./relaceai').then((module) => module.technologyIcon),
  remix: () => import('./remix').then((module) => module.technologyIcon),
  render: () => import('./render').then((module) => module.technologyIcon),
  replit: () => import('./replit').then((module) => module.technologyIcon),
  resend: () => import('./resend').then((module) => module.technologyIcon),
  rollup: () => import('./rollup').then((module) => module.technologyIcon),
  roocode: () => import('./roocode').then((module) => module.technologyIcon),
  rovoai: () => import('./rovoai').then((module) => module.technologyIcon),
  rsshub: () => import('./rsshub').then((module) => module.technologyIcon),
  ruby: () => import('./ruby').then((module) => module.technologyIcon),
  rust: () => import('./rust').then((module) => module.technologyIcon),
  rwkv: () => import('./rwkv').then((module) => module.technologyIcon),
  safari: () => import('./safari').then((module) => module.technologyIcon),
  sambanova: () => import('./sambanova').then((module) => module.technologyIcon),
  sass: () => import('./sass').then((module) => module.technologyIcon),
  scala: () => import('./scala').then((module) => module.technologyIcon),
  search1api: () => import('./search1api').then((module) => module.technologyIcon),
  segment: () => import('./segment').then((module) => module.technologyIcon),
  semanticui: () => import('./semanticui').then((module) => module.technologyIcon),
  sensenova: () => import('./sensenova').then((module) => module.technologyIcon),
  sentry: () => import('./sentry').then((module) => module.technologyIcon),
  serverless: () => import('./serverless').then((module) => module.technologyIcon),
  shadcnui: () => import('./shadcnui').then((module) => module.technologyIcon),
  siliconcloud: () => import('./siliconcloud').then((module) => module.technologyIcon),
  sketch: () => import('./sketch').then((module) => module.technologyIcon),
  sketch2: () => import('./sketch2').then((module) => module.technologyIcon),
  skyworkai: () => import('./skyworkai').then((module) => module.technologyIcon),
  slack: () => import('./slack').then((module) => module.technologyIcon),
  snowflake: () => import('./snowflake').then((module) => module.technologyIcon),
  snyk: () => import('./snyk').then((module) => module.technologyIcon),
  solidity: () => import('./solidity').then((module) => module.technologyIcon),
  solidjs: () => import('./solidjs').then((module) => module.technologyIcon),
  soraai: () => import('./soraai').then((module) => module.technologyIcon),
  spark: () => import('./spark').then((module) => module.technologyIcon),
  spring: () => import('./spring').then((module) => module.technologyIcon),
  stability: () => import('./stability').then((module) => module.technologyIcon),
  statecloud: () => import('./statecloud').then((module) => module.technologyIcon),
  stepfun: () => import('./stepfun').then((module) => module.technologyIcon),
  storyblok: () => import('./storyblok').then((module) => module.technologyIcon),
  storybook: () => import('./storybook').then((module) => module.technologyIcon),
  strada: () => import('./strada').then((module) => module.technologyIcon),
  stream: () => import('./stream').then((module) => module.technologyIcon),
  streamlit: () => import('./streamlit').then((module) => module.technologyIcon),
  stripe: () => import('./stripe').then((module) => module.technologyIcon),
  stylelint: () => import('./stylelint').then((module) => module.technologyIcon),
  sublime: () => import('./sublime').then((module) => module.technologyIcon),
  supabase: () => import('./supabase').then((module) => module.technologyIcon),
  sveltejs: () => import('./sveltejs').then((module) => module.technologyIcon),
  swagger: () => import('./swagger').then((module) => module.technologyIcon),
  swift: () => import('./swift').then((module) => module.technologyIcon),
  tRPC: () => import('./tRPC').then((module) => module.technologyIcon),
  tailwindcss: () => import('./tailwindcss').then((module) => module.technologyIcon),
  tanstack: () => import('./tanstack').then((module) => module.technologyIcon),
  tanstack2: () => import('./tanstack2').then((module) => module.technologyIcon),
  targon: () => import('./targon').then((module) => module.technologyIcon),
  techstackicons: () => import('./techstackicons').then((module) => module.technologyIcon),
  tencent: () => import('./tencent').then((module) => module.technologyIcon),
  tencentcloud: () => import('./tencentcloud').then((module) => module.technologyIcon),
  terraform: () => import('./terraform').then((module) => module.technologyIcon),
  threejs: () => import('./threejs').then((module) => module.technologyIcon),
  tiangong: () => import('./tiangong').then((module) => module.technologyIcon),
  tii: () => import('./tii').then((module) => module.technologyIcon),
  tinyhttp: () => import('./tinyhttp').then((module) => module.technologyIcon),
  together: () => import('./together').then((module) => module.technologyIcon),
  trello: () => import('./trello').then((module) => module.technologyIcon),
  tripo: () => import('./tripo').then((module) => module.technologyIcon),
  turborepo: () => import('./turborepo').then((module) => module.technologyIcon),
  twilio: () => import('./twilio').then((module) => module.technologyIcon),
  typescript: () => import('./typescript').then((module) => module.technologyIcon),
  ubuntu: () => import('./ubuntu').then((module) => module.technologyIcon),
  udio: () => import('./udio').then((module) => module.technologyIcon),
  unjs: () => import('./unjs').then((module) => module.technologyIcon),
  unsplash: () => import('./unsplash').then((module) => module.technologyIcon),
  unstructured: () => import('./unstructured').then((module) => module.technologyIcon),
  upstage: () => import('./upstage').then((module) => module.technologyIcon),
  ur: () => import('./ur').then((module) => module.technologyIcon),
  v0: () => import('./v0').then((module) => module.technologyIcon),
  vercel: () => import('./vercel').then((module) => module.technologyIcon),
  vertexai: () => import('./vertexai').then((module) => module.technologyIcon),
  vidu: () => import('./vidu').then((module) => module.technologyIcon),
  vim: () => import('./vim').then((module) => module.technologyIcon),
  visualbasic: () => import('./visualbasic').then((module) => module.technologyIcon),
  vitejs: () => import('./vitejs').then((module) => module.technologyIcon),
  vitest: () => import('./vitest').then((module) => module.technologyIcon),
  vllm: () => import('./vllm').then((module) => module.technologyIcon),
  volcengine: () => import('./volcengine').then((module) => module.technologyIcon),
  voyage: () => import('./voyage').then((module) => module.technologyIcon),
  vscode: () => import('./vscode').then((module) => module.technologyIcon),
  vuejs: () => import('./vuejs').then((module) => module.technologyIcon),
  webassembly: () => import('./webassembly').then((module) => module.technologyIcon),
  webpack: () => import('./webpack').then((module) => module.technologyIcon),
  wenxin: () => import('./wenxin').then((module) => module.technologyIcon),
  windsurf: () => import('./windsurf').then((module) => module.technologyIcon),
  wordpress: () => import('./wordpress').then((module) => module.technologyIcon),
  workersai: () => import('./workersai').then((module) => module.technologyIcon),
  xamarin: () => import('./xamarin').then((module) => module.technologyIcon),
  xd: () => import('./xd').then((module) => module.technologyIcon),
  xinference: () => import('./xinference').then((module) => module.technologyIcon),
  xuanyuan: () => import('./xuanyuan').then((module) => module.technologyIcon),
  yi: () => import('./yi').then((module) => module.technologyIcon),
  yoga: () => import('./yoga').then((module) => module.technologyIcon),
  yuanbao: () => import('./yuanbao').then((module) => module.technologyIcon),
  zapier: () => import('./zapier').then((module) => module.technologyIcon),
  zeabur: () => import('./zeabur').then((module) => module.technologyIcon),
  zed: () => import('./zed').then((module) => module.technologyIcon),
  zhipu: () => import('./zhipu').then((module) => module.technologyIcon),
  zod: () => import('./zod').then((module) => module.technologyIcon),
  zola: () => import('./zola').then((module) => module.technologyIcon),
};
